import CourseGridIconOne from "@/svg/course-grid-icon-one";
import CourseGridIconTwo from "@/svg/course-grid-icon-two";
import { current } from "@reduxjs/toolkit";
import { Translations } from "@/translations";
import { useTranslations } from "next-intl";

interface PaginationHeaderProps {
  setView: (s: "grid" | "list") => void;
  setNumber: (n: number) => void;
  itemsPerPage: number;
  currentPage: number;
  viewType: "grid" | "list";
  totalItems: number;
}

const PaginationHeader = ({
  setView,
  setNumber,
  itemsPerPage,
  currentPage,
  viewType,
  totalItems,
}: PaginationHeaderProps) => {
  const t = useTranslations('Courses');
  if (totalItems === 0) return null;
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(startItem + itemsPerPage - 1, totalItems);
  return (
    <>
      <div className="course__tab-inner grey-bg-2 mb-50">
        <div className="row align-items-center">
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
            <div className="course__tab-wrapper d-flex align-items-center">
              <div className="course__tab-btn">
                <ul className="nav nav-tabs" id="courseTab" role="tablist">
                  {/* <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${
                        viewType === "grid" ? "active" : ""
                      }`}
                      id="grid-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#grid"
                      type="button"
                      role="tab"
                      aria-controls="grid"
                      aria-selected="true"
                      onClick={() => setView("grid")}
                    >
                      <CourseGridIconOne />
                    </button>
                  </li> */}
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link list ${
                        viewType === "list" ? "active" : ""
                      }`}
                      id="list-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#list"
                      type="button"
                      role="tab"
                      aria-controls="list"
                      aria-selected="false"
                      onClick={() => setView("list")}
                    >
                      <CourseGridIconTwo />
                    </button>
                  </li>
                </ul>
              </div>
              <div className="course__view">
                {}
                <h4>
                  {t(Translations.Courses.Showing)} {startItem} - {endItem} {t(Translations.Courses.Of)} {totalItems}
                </h4>
              </div>
            </div>
          </div>
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
            <div className="course__sort d-flex justify-content-sm-end">
              <div className="course__sort-inner">
                <select className="course__select" onChange={(e) => setNumber(Number(e.target.value))}>
                  <option value={1}>{t(Translations.Courses.Quizzes_Per_Page)}</option>
                  {/* <option value={1}>1 Course</option> */}
                  <option value={2}>2 {t(Translations.Courses.Title)}</option>
                  <option value={3}>3 {t(Translations.Courses.Title)}</option>
                  <option value={4}>4 {t(Translations.Courses.Title)}</option>
                  <option value={5}>5 {t(Translations.Courses.Title)}</option>
                  <option value={6}>6 {t(Translations.Courses.Title)}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaginationHeader;
